export const OPTIONAL_KEYS = [ "alignment", "inspection", "pm", "towing" ];
export const STATUS_COLOR = {
	1: '#8F90A6',
	2: '#4E7AED',
	3: '#19BC38',
	4: '#e91e63',
	5: '#F49741',
	6: '#8F90A6',
	7: '#e91e63',
	8: '#00E0FF',
	9: '#8f3e00',
	10: '#fff',
	11: '#ff0000'
};

export const STATUS_TRUCK_COLOR = {
	1: '#a39493',
	2: '#3122d6',
	3: '#1cdb07',
	4: '#db0715',
	5: '#fc7514',
	6: '#a39493',
	7: '#db0715',
	8: '#14e5fc'
};

export const TABLE_COLOR = {
	1: 'rgba(244, 151, 65, 0.35)',
	2: 'rgba(244, 65, 65, 0.35)',
	3: 'rgba(80,80,80,0.3)',
	4: 'rgba(249,255,65,0.07)',
	5: 'rgb(38 162 65 / 12%)',
};

export const PAGE_NAMES = {
	SYSTEM_SETTINGS: 'System Settings',
};

export const PAGE = {
	DRIVERS: 'drivers',
	TRUCKS: 'trucks',
	TRAILERS: 'trailers',
	USERS: 'users',
	WORK_ORDERS: 'workOrders',
	CUSTOMERS: 'customers',
	SHORT_PAYMENTS: 'shortPayments',
	TRIP_LIST: 'tripList',
	TRIP_PAYMENTS: 'tripPayments',
	TRIP_NOTES: 'tripNotes',
	TRIP_FILES: 'tripFiles',
	TRIP_PAPER_WORK: 'tripPaperWork',
	TRIP_PICKUP_DELIVERY: 'TripPickupDelivery',
	TRIP_PICKUP_DELIVERY_ITEM: 'TripPickupDeliveryItem',
	TRIP_BILLING: 'Billing',
	BILLING: 'billingPage',
	FACTORING: 'factoring',
	CUSTOMER_PAYMENTS: 'customerPayments',
	REPORT_LIST: 'dispatchTable',
	REPORT_BILLING: 'billingTable',
	REPORT_SAFETY: 'safetyTable',
	LOGBOOKS: 'logbooks',
	LOGBOOKSMOD: 'logbooksMod',
	DISPATCH_STATISTICS: 'dispatchStatistics',
	INVOICE: 'invoice',
	CUSTOMER_INVOICE: 'customer_invoice',
	MANAGER_STATEMENTS: 'managerStatements',
	EMPLOYEES: 'employees',
	BROKERS: 'brokers',
	CITIES: 'cities',
	DRIVER_STATEMENTS: 'driverStatements',
	TABSCHEDULE: 'tabSchedule',
	LOST_PAYMENTS: 'lostPayments',
	PAYMENTS_CUSTOMER: 'paymentsCustomer',
	CUSTOMER_INVOICE_ITEMS: 'customerInvoiceItems',
	SAFETY_STATISTIC: 'safetyStatistic',
	INCOME_TRANSACTIONS: 'incomeTransactions',
};

export const FILTER_KEYS = {
	SAFETY: 'safety',
	SERVICE: 'service',
	COMPANY_OWNER: 'company_owner',
	ACTIVE: 'active',
	LEFT_COMPANY: 'left_company',
	SOLD: 'sold',
	STATUS: 'status',
	AI_STATUS: 'ai_status',
	CHECK_IN: 'check_in',
	CHECK_OUT: 'check_out',
	ROUTS: 'routs',
	BALANCE: 'balance',
	TRIP_ID: 'trip_id',
	LOAD_ID: 'load_id',
	INVOICE_ID: 'invoice_id',
	ELD: 'eld',
	ARRIVED: 'arrived',
	FROZEN: 'frozen',
	STATUS_SERVES: 'status_serves',
	BOL: 'bol',
	JOIN_PPW: 'join_ppw',
	OPTIONAL: 'optional',
	CONSIDER_BOOLEAN: 'considerBoolean',
	GPS: 'gps',
	DESCRIPTION: 'description',
	FILTER_STATUS: 'filter_status',
	ASSIGNED: 'assigned',
	PAID: 'paid',
};
export const TAB = {
	ACCOUNT_TAB_VACATION: 'AccountTabVacation',
	ACCOUNT_TAB_ALL_USERS_COMMENTS: 'AccountTabAllUsersComments',
	ACCOUNT_TAB_STATEMENTS: 'AccountTabStatements',
	USER_TAB_ST_ST__DISPATCHERS: 'accountTabStSt-Dispatchers',
	USER_TAB_ST_ST__MANAGER: 'user-managerStatements',
	USER_TAB_ST_ST__SAFETY: 'user-safetyStatements',
	USER_TAB_ST_ST__ALL: 'user-AllStatements',
	USER_TAB_BONUS_CHARGE: 'user-bonus-charge',
	ACCOUNT_TAB_BONUS_CHARGE: 'account-bonus-charge',
	USER_TAB_SALARY_HISTORY_SLIDE: 'userSalaryHistorySlide',
	ACCOUNT_TAB_SALARY_HISTORY_SLIDE: 'accountSalaryHistorySlide',
	TAB_SET_SCHEDULE: 'tabSetSchedule',
	HOLIDAYS: 'tabHolidays',
	OFFICE: 'tabOffice',
	INVENTORY: 'tabInventory',
	NOTIFICATIONS: 'tabNotifications',
	CONTACTS_TYPES: 'tabContactsTypes',
	DOCUMENTS_TYPES: 'tabDocumentsTypes',
	DEPARTMENTS: 'tabDepartments',
	POSITIONS: 'tabPositions',
	COMPANIES: 'tabCompanies',
	EXCEPTION_TABLE_MODAL: 'exceptionTableModal'
};

export const STATUS_TEXT = {
	ACTIVE: 'Active',
	INACTIVE: 'Inactive',
};

export const TRAILER_TYPE = {
	REEFER: 'reefer',
};
export const PERMISSIONS = {
	CREATE: 8,
	EDIT: 9,
	VIEW: 10,
	DELETE: 11,
	EXPORT: 72,
	CHANGE_BINDING: 28,
	VIEW_DOC: 13,
	DOWNLOAD_DOC: 14,
	SEND: 15,
	PAID: 16,
	GENERATED_BY: 38,
	DELETE_SUPERIAL_PERMISSION: 39,
	CREATE_EDIT_TRIP: 19,
	DELETE_TRIP: 40,
	ADD_NEW_BROKER: 21,
	DELETE_LOAD: 22,
	UPLOAD_FILES: 23,
	VIEW_FILES: 24,
	DOWNLOAD_FILES: 25,
	DELETE_FILES: 26,
	BILLING_CREATE: 45,
	BILLING_VIEW: 51,
	TOTAL_VALUE: 65,
	INVOICING: 66,
	// =========================
	ACCOUNT: 89,
	ACCOUNT_USERS: 91,
	ACCOUNT_ST_TS: 92,
	ACCOUNT_COMMENTS: 93,
	ACCOUNT_BONUS_CHARGE: 94,
	ACCOUNT_MY_INFO: 95,
	ACCOUNT_SALARY_HISTORY: 96,
	ACCOUNT_VACATION: 97,
	ACCOUNT_EVENTS: 98,
	ACCOUNT_GEO: 99,
	ACCOUNT_USER_COMMENTS: 101,
	ACCOUNT_USER_SALARY_HISTORY: 103,
	ACCOUNT_USER_VACATION: 104,
	ACCOUNT_USER_EVENTS: 105,
	ACCOUNT_USER_GEO: 106,
	ACCOUNT_USER_BONUS_CHARGE: 118,
	OPEN_INVOICE: 117,
	// ====
	PROFILE: 52,
	// ====
	DISPATCH: 53,
	DASHBOARD: 27,
	TRIPS: 18,
	// ====
	SAFETY: 54,
	LOGBOOKS: 55,
	// ====
	STATISTICS: 56,
	CUSTOMER_NOT_PAID_INVOICES: 62,
	DISPATCH_STATISTICS: 58,
	REPORTS: 48,
	// ====
	ACCOUNTING: 42,
	SCHEDULES: 60,
	SCHEDULED_PAYMENTS: 79,
	SHORT_PAYMENTS: 61,
	BILLING: 57,
	CUSTOMER_INVOICES: 12,
	CUSTOMER_INVOICE_ITEMS: 47,
	CUSTOMER_PAYMENTS: 46,
	DISPATCHERS_STATEMENTS: 50,
	// ====
	MAINTENANCE: 1,
	GENERAL: 2,
	DRIVERS: 5,
	TRUCKS: 3,
	TRAILERS: 4,
	CUSTOMERS: 6,
	EMPLOYEES: 7,
	CITIES: 35,
	BROKERS: 36,
	FACTORING_COMPANIES: 59,
	USERS: 33,
	ROLES: 37,
	// ====
	SETTINGS: 32,
	ACCOUNT_SETTINGS: 43,
	SYSTEM_SETTINGS: 44,
	// ========
	MAIL: 74,
	MAP_KEYS: 75,
	TRAILER_TYPES: 76,
	TAB_TRUCKS_ON_THE_ROAD: 78,
	TAB_STATISTICS: 77,
	// ========
	// ====
	FLEET: 63,
	WORK_ORDERS_STATISTICS: 67,
	// ========
	ANALYTICS: 68,
	PLANNER: 69,
	DOWNTIME: 70,
	MOTIVATION_PROGRAMM: 73,
	// ========
	TRUCKS_ON_THE_ROAD: 71,
	WORK_ORDERS: 64,
	LOST_PAYMENTS: 119,
	INVOICE_GENERATOR: 121,
	
	USER_ACCOUNT_SETTINGS: 107,
	U_A_S_SCHEDULE: 108,
	U_A_S_HOLIDAYS: 109,
	U_A_S_OFFICE: 110,
	U_A_S_INVENTORY: 111,
	U_A_S_CONTACTS: 112,
	U_A_S_DOCUMENTS: 113,
	U_A_S_DEPARTMENTS: 114,
	U_A_S_POSITIONS: 115,
	U_A_S_COMPANY: 116,
	INCOME_TRANSACTIONS: 122,
};

//32 SETTINGS
//107 USER_ACCOUNT_SETTINGS

export const DRIVER_STATEMENTS_FLAGS = {
	TRIPS: 'trips',
	FUEL: 'fuel',
	SCHEDULE_PAYMENTS: 'schedulePayments',
	ADDITION_PAYMENTS: 'additionalPayments',
};

export const TYPE_OF_COUNT = {
	DEDUCTION: 'Deduction',
	CREDIT: 'Credit',
	CATEGORY: 'category',
	BONUS: 'Bonus',
	CHARGE: 'Charge',
	SALARY: 'Salary',
	TYPE: 'type',
	AMOUNT: 'amount',
	TOTAL: 'total'
};
export const TITLE = {
	OPEN_INVOICE: 'Open invoice',
	DELETE_INVOICE: 'Delete invoice',
	DELETE_VACATION: 'Delete leave request.',

};
export const TEXT = {
	OPEN_INVOICE: 'Warning: Opening this invoice may expose sensitive financial data. Verify the sender, check for malware, and confirm details before proceeding. 🚨',
	DELETE_INVOICE: 'Are you sure? This invoice will be permanently deleted. ⚠️',
	DELETE_VACATION: 'Are you sure? This leave request will be permanently deleted. ⚠️',
};
